import { WaitingDots } from 'components/WaitingDots/WaitingDots';
import { confirmEmailOnEnterSaga } from './ConfirmEmail.onenter.saga';

export const ConfirmEmailRoute = (store, client) => ({
  path: '/confirm/:key',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(confirmEmailOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),
  component: WaitingDots,
});
